import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch } from '@/redux/hooks';
import { openExcludeHouseModal } from '@/redux/modules/modal';

import {
    PopoverContentContainer,
    PopoverMenuItem,
    PopoverWrapper,
    StyledMenuContainer,
    StyledMenuIcon,
    StyledPopover,
    TriggerWrapper,
} from './helpers/excludePopupStyles';
export interface ExcludeFacetMenuProps {
    excludeByHouseId: (houseId: number) => void;
    isMobileView: boolean;
    optionId: number;
}

const ExcludeFacetMenu = ({ excludeByHouseId, isMobileView, optionId }: ExcludeFacetMenuProps) => {
    const dispatch = useAppDispatch();

    const showExcludeConfirmation = React.useCallback(async () => {
        if (isMobileView) {
            excludeByHouseId(optionId);
        } else {
            dispatch(openExcludeHouseModal(optionId));
        }
    }, [dispatch, excludeByHouseId, isMobileView, optionId]);

    return (
        <StyledMenuContainer
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            <PopoverWrapper>
                <StyledPopover
                    childrenClickClosesPopover
                    click
                    hover={false}
                    placement={isMobileView ? 'left' : 'right'}
                    portalTarget="body"
                    showArrow={false}
                    trigger={
                        <TriggerWrapper>
                            <StyledMenuIcon
                                size="sm"
                                style="fill"
                            />
                        </TriggerWrapper>
                    }
                >
                    <PopoverContentContainer>
                        <PopoverMenuItem>
                            <ShouldLogInContainer runFunction={showExcludeConfirmation}>
                                <BodySecondary>
                                    <FormattedMessage id="search_facet_add_exclusion" />
                                </BodySecondary>
                            </ShouldLogInContainer>
                        </PopoverMenuItem>
                    </PopoverContentContainer>
                </StyledPopover>
            </PopoverWrapper>
        </StyledMenuContainer>
    );
};

export default ExcludeFacetMenu;
